import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AdminSubpage from '../components/AdminSubpage';
import OrderDetails from '../components/OrderDetails';
import { ordersAPI } from '../services/api';
import { isInfluencerUser } from '../utils/auth';

const unwrapOrder = (raw) => {
  if (!raw || typeof raw !== 'object') return null;
  if ('order_number' in raw || 'id' in raw) return raw;
  return raw?.data ?? raw?.order ?? null;
};

const OrderDetailPage = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const readOnly = isInfluencerUser();

  const load = useCallback(async () => {
    if (!orderId) return;
    setLoading(true);
    try {
      const response = await ordersAPI.getById(orderId);
      const detail = unwrapOrder(response.data);
      setOrder(detail);
      if (!detail) {
        toast.error('Could not load order details.');
      }
    } catch (error) {
      toast.error(
        'Error loading order: ' + (error.response?.data?.message || error.message)
      );
      setOrder(null);
    } finally {
      setLoading(false);
    }
  }, [orderId]);

  useEffect(() => {
    void load();
  }, [load]);

  const handleUpdated = () => {
    void load();
  };

  const title = order?.order_number ? `Order ${order.order_number}` : 'Order details';

  return (
    <AdminSubpage title={title} backTo="/orders">
      {loading ? (
        <div className="loading">Loading order…</div>
      ) : order ? (
        <OrderDetails
          order={order}
          onUpdate={handleUpdated}
          onDelete={() => navigate('/orders')}
          readOnly={readOnly}
        />
      ) : (
        <p>No order loaded.</p>
      )}
    </AdminSubpage>
  );
};

export default OrderDetailPage;
